import { useMemo } from "react";
import tenants from "../tenants/index.js";

const useTenant = () => {
  const tenant = useMemo(() => {
    const host = window.location.hostname;
    // console.log(host,"hostttttttttttttttt")
    // const tenantKey = host.split(".")[0];
    const tenantKey = host.split(".")[1];
    return tenants[tenantKey] || tenants["floorwalk"];
    // return tenants["hsbrandsasia"] ;
  }, []);

  return tenant;
};

export default useTenant;
